var React = require('react');

function Columns (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M288 160v256h160V160zM64 416h160V160H64z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M464 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48zM224 416H64V160h160zm224 0H288V160h160z","className":"fa-primary","key":2})]);
}

Columns.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Columns;

Columns.default = Columns;
